module.exports = __webpack_public_path__ + "static/media/iconEdit.4ad81b0c.svg";